import { EmailInviteTypeDto } from "../../../autogen/bff-api";

export const parseEmailInviteType = (type: string | null): EmailInviteTypeDto | null =>
  type !== null && type in EmailInviteTypeDto ? EmailInviteTypeDto[type as keyof typeof EmailInviteTypeDto] : null;
